"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autoship = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Image_1 = require("./Image");
const AutoshipModal_1 = require("./AutoshipModal");
const translations_1 = require("../i18n/translations");
function Autoship(_a) {
    var { className, linkProps, linkClassName, itemFrequency, handleAutoshipFunction, removeAutoship, productId, type, locale = 'en' } = _a, props = __rest(_a, ["className", "linkProps", "linkClassName", "itemFrequency", "handleAutoshipFunction", "removeAutoship", "productId", "type", "locale"]);
    const { autoshipSetupLink, autoshipMonth, autoshipMonths, autoshipQuarterly, autoshipFrequencyLabel, autoshipSelectFrequency, autoshipCancelEdit, autoshipEdit, } = translations_1.cartContent[locale];
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const toggleModalIsOpen = (toggleOpen) => {
        setIsModalOpen(toggleOpen);
    };
    const [autoshipFrequency, setautoshipFrequency] = (0, react_1.useState)(3);
    const toggleAutoshipInputIsOpen = (e) => {
        const { checked } = e.target;
        if (checked) {
            handleAutoshipFunction(autoshipFrequency);
        }
        else {
            removeAutoship();
        }
    };
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const toggleIsEditing = (toggleEditOpen) => {
        setIsEditing(toggleEditOpen);
    };
    const handleAutoshipFrequency = (frequency) => {
        setautoshipFrequency(frequency);
        handleAutoshipFunction(frequency);
        if (isEditing) {
            setIsEditing(false);
        }
    };
    const [frequencyText, setFrequencyText] = (0, react_1.useState)('');
    const [isChecked, setIsChecked] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let text = '';
        if (itemFrequency === 'quarterly') {
            text = autoshipQuarterly;
        }
        else if (itemFrequency === '1') {
            text = `1 ${autoshipMonth}`;
        }
        else {
            text = `${itemFrequency} ${autoshipMonths}`;
        }
        setFrequencyText(text);
    }, [itemFrequency, locale]);
    (0, react_1.useEffect)(() => {
        setIsChecked(!!itemFrequency);
        if (itemFrequency) {
            // convert string value to number to match select values
            setautoshipFrequency(+itemFrequency);
        }
    }, [itemFrequency]);
    return (react_1.default.createElement("div", { className: "flex flex-col" },
        react_1.default.createElement("label", { htmlFor: "autoship-input-0", className: "flex py-3 pr-3 relative" },
            react_1.default.createElement("input", { id: "autoship-input-0", className: "block absolute rounded border border-borderColor inline-block mr-2 cursor-pointer top-5", type: "checkbox", onChange: toggleAutoshipInputIsOpen, checked: isChecked, "data-testid": `autoship-checkbox-${productId}` }),
            react_1.default.createElement(Image_1.Image, { className: "pl-8 max-h-7 inline-block", src: "/autoshiplogo_300x61?hei=32&fmt=png-alpha", alt: "Autoship" })),
        type === 'Custom Frequency' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)('text-sm mt-2 md:mb-0', {
                    hidden: !isEditing,
                }) },
                react_1.default.createElement("label", { className: "sr-only", htmlFor: "autoship-frequency-select-0" }, autoshipSelectFrequency),
                react_1.default.createElement("select", { id: "autoship-frequency-select-0", className: "inline-block rounded border border-borderColor mr-4 text-sm mb-1 py-2 pl-3 pr-10", onChange: (e) => handleAutoshipFrequency(e.target.value), value: autoshipFrequency },
                    react_1.default.createElement("option", { value: 0 }, autoshipSelectFrequency),
                    react_1.default.createElement("option", { value: 1 },
                        "1 ",
                        autoshipMonth),
                    react_1.default.createElement("option", { value: 3 },
                        "3 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 6 },
                        "6 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 9 },
                        "9 ",
                        autoshipMonths),
                    react_1.default.createElement("option", { value: 12 },
                        "12 ",
                        autoshipMonths)),
                autoshipFrequency > 0 && (react_1.default.createElement("button", { className: "inline-block decoration-solid text-blue hover:text-blue-hover focus:text-blue-hover focus:underline hover:underline", onClick: () => toggleIsEditing(false) }, autoshipCancelEdit))))),
        itemFrequency && (react_1.default.createElement("div", { className: "text-sm pl-8 mb-3" },
            react_1.default.createElement("span", { className: "font-bold" },
                autoshipFrequencyLabel,
                ": "),
            frequencyText,
            react_1.default.createElement("button", { className: (0, classnames_1.default)('pl-4 inline-block decoration-solid text-blue hover:text-blue-hover focus:text-blue-hover focus:underline hover:underline py-2', {
                    hidden: type === 'Fixed Frequency',
                }), "aria-label": "Edit Autoship Frequency", onClick: () => toggleIsEditing(true) }, autoshipEdit))),
        react_1.default.createElement("button", { className: "inline-block w-full text-left decoration-solid text-blue hover:text-blue-hover focus:text-blue-hover focus:underline hover:underline text-sm", onClick: () => toggleModalIsOpen(true) },
            autoshipSetupLink,
            " ",
            react_1.default.createElement("strong", null, "autoship")),
        react_1.default.createElement(AutoshipModal_1.AutoshipModal, { isOpen: isModalOpen, toggleModalIsOpen: toggleModalIsOpen })));
}
exports.Autoship = Autoship;
